module.exports = __webpack_public_path__ + "static/media/icon_axis_selected.815c6631.svg";